module.exports = __webpack_public_path__ + "img/PSSS-M-13.db37baaf.svg";